import { Avatar } from "@velaro/velaro-component-lib/";
import React, { useState } from "react";
import StatusBadge, { BaseStatus } from "@/components/StatusBadge";

/** Maps raw status strings (including component-lib aliases) to a BaseStatus. */
function resolveBaseStatus(status: string): BaseStatus {
  if (status === "Available") return "Available";
  if (status === "Away" || status === "Unavailable") return "Away";
  return "Offline";
}

interface ProfileButtonProps {
  picture: string;
  /** Raw status string from StatusContext */
  status: string;
  label?: string;
  onToggle: () => void;
  toggleSidebar?: boolean;
}

export default function ProfileButton({
  picture,
  status,
  label,
  onToggle,
  toggleSidebar
}: ProfileButtonProps) {
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const baseStatus = resolveBaseStatus(status);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setShowProfileMenu(!showProfileMenu);
    onToggle();
  };

  return (
    <button
      className="w-full flex items-center justify-start relative py-2"
      onClick={handleClick}
    >
      <div className="relative flex-shrink-0">
        <div className="v-avatar-sq">
          <Avatar
            name={label}
            url={picture}
            size={toggleSidebar ? 48 : 32}
            fontSize={toggleSidebar ? 24 : 20}
          />
        </div>
        {toggleSidebar ? (
          // Expanded sidebar — full badge with icon
          <StatusBadge
            baseStatus={baseStatus}
            label={status}
            variant="badge"
            className="absolute -bottom-1 -right-1"
          />
        ) : (
          // Collapsed sidebar — compact dot
          <StatusBadge
            baseStatus={baseStatus}
            label={status}
            variant="dot"
            className="absolute bottom-0 right-0"
          />
        )}
      </div>
      {toggleSidebar && (
        <div className="ml-4 text-white overflow-hidden whitespace-nowrap text-ellipsis">
          {label}
        </div>
      )}
    </button>
  );
}
